/**
 * 장지 상세용 아이콘. 단순한 도형으로만 그린다.
 * 색은 currentColor 를 따라가서 카드 배경에 맞춰 쓸 수 있다.
 */
interface IconProps {
  size?: number;
}

/** 자연장 (수목장, 화초장, 잔디장) */
export const TreeIcon = ({ size = 20 }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 3.5L6.5 11h11L12 3.5z" />
    <path d="M12 9.5L7 16.5h10L12 9.5z" />
    <path d="M12 16.5v4" />
  </svg>
);

/** 봉안당 (납골당) */
export const UrnIcon = ({ size = 20 }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="4" y="7.5" width="16" height="13" rx="1.5" />
    <path d="M4 12h16M12 7.5v13M3 7.5l9-4 9 4" />
  </svg>
);

/** 묘지 */
export const GraveIcon = ({ size = 20 }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M7 20.5V9a5 5 0 0 1 10 0v11.5" />
    <path d="M4 20.5h16M10 12.5h4M12 12.5v4" />
  </svg>
);

/** 주차 */
export const ParkingIcon = ({ size = 20 }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 13.5l1.7-5A2 2 0 0 1 7.6 7h8.8a2 2 0 0 1 1.9 1.5l1.7 5" />
    <path d="M3.5 13.5h17v4h-17zM6.5 17.5v1.8M17.5 17.5v1.8" />
  </svg>
);

/** 운영 형태 (공설, 사설) */
export const BuildingIcon = ({ size = 20 }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="4.5" y="4" width="15" height="16.5" rx="1.5" />
    <path d="M8.5 8h2.5M13 8h2.5M8.5 12h2.5M13 12h2.5M10.5 20.5v-4h3v4" />
  </svg>
);

/** 안치 기간 */
export const ClockIcon = ({ size = 20 }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3.2 2" />
  </svg>
);

/** 유형에 맞는 아이콘 */
export const FacilityTypeIcon = ({
  typeLabel,
  size = 22,
}: IconProps & { typeLabel: string }) => {
  if (typeLabel === "자연장") return <TreeIcon size={size} />;
  if (typeLabel === "묘지") return <GraveIcon size={size} />;
  return <UrnIcon size={size} />;
};
